import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormTitle from "../../../../library/form/components/FormTitle";
import FormLabel from '../../../../library/form/components/FormLabel'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo, UiCol } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const RoleHeaderViewer = (props) => {
    const { formObject, viewData } = props;

    if(!viewData)
        return(null)
        
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Role Header' />
                    </span>
                </UiTitle>

                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColTwo>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "roleId" }} value="Role ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "roleId" }}
                                    id='svAddType' className="uiInline uiHeaderElement"
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "roleName" }} value="Role Name" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "roleName" }}
                                    id='svAddType' className="uiInline uiHeaderElement"
                                />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "roleDesc" }} value="Role Description" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "roleDesc" }}
                                    id='svAddType' className="uiInline uiHeaderElement"
                                />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColTwo>
            </UiViewContent>
        </UiView>
    )
}

export default withView(RoleHeaderViewer, "roleHead", "roleHead")